import { render, staticRenderFns } from "./SearchResultCard.vue?vue&type=template&id=98f771fe&scoped=true&"
import script from "./SearchResultCard.vue?vue&type=script&lang=ts&"
export * from "./SearchResultCard.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultCard.vue?vue&type=style&index=0&id=98f771fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f771fe",
  null
  
)

export default component.exports